module.exports = __webpack_public_path__ + "static/media/background.d652a5ef.avif";